import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Button, Modal, Alert, Table, Card } from "react-bootstrap";
import { LuDownload, LuArrowDownToLine, LuArrowUpToLine, LuSquareArrowUp } from "react-icons/lu";
import { Link, useLocation, useParams } from "react-router-dom";
import { useForm, Controller } from 'react-hook-form';
import CommonPagination from '../utils/CommonPagination';
import API from "../../services/axiosInstance"
import Pagination from '../common_modules/pagination';
import FilterBar from '../common_modules/filter';
import { FormLoader, useFormLoader } from "../common_modules/loader";
import Permission from '../security/permission';
import { AUTH_CODE } from '../security/authCodes';
// import useSubmitPrevent from "../utils/SubmitPrevent"
import usePreventMultiClick from '../utils/SubmitPrevent';
import { SearchIcon } from '../common_modules/commonIcons';

const PubInvoiceList = () => {
    const [invoiceList, setInvoiceList] = useState([]);
    const [actionModal, setActionModal] = useState(false);
    const [selectedPub, setSelectedPub] = useState(null);
    const [publisherName, setPublisherName] = useState("");
    // const [actionType, setActionType] = useState(null);

    // pagination & filter state
    const [paginationData, setPaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState({});

    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

    // const location = useParams();
    const { guid: pubGuid, id: pubId } = useParams();
    const { handleSubmit, register, reset, formState: { errors }, } = useForm({});

    // Prevent button mutilple clicks
    // const submittingRef  = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();
    // const tableFields = [
    //     { label: "Name", value: "name", enableSorting: true },
    //     { label: "ID", value: "accId", enableSorting: true },
    // ];

    const tableFields = [
        { label: "Id", value: "id", enableSorting: true, enableTableHeader: false, enableIcon: true },
        { label: "Invoice Series", value: "invoiceSeries", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Invoice Month", value: "invoice_month", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Invoice Year", value: "invoiceYear", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Payment Date", value: "paymentDate", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Payment Amount", value: "paymentAmount", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Description", value: "description", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Approve Status", value: "approveStatus", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Invoice File", value: "invoiceFile", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Invoice Status", value: "invoiceStatus", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Status", value: "status", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Created On", value: "", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Updated On", value: "", enableSorting: false, enableTableHeader: true, enableIcon: false },
    ];

    const openActionModal = (invoice) => {
        setActionModal(true);
        setSelectedPub(invoice);
        // setActionType(action);  // "draft" | "publish"
    }

    const closeActionModal = () => {
        setActionModal(false);
        setSelectedPub(null);
        //   setActionType(null); 
        reset();
    }
    const manageInvoiceList = async (search, page, field = tableFields[0].value, order = "asc") => {
        startLoading();
        try {
            const size = 10;
            // is finance = 0 in case of publisher invoice
            // const invoiceList = await API.get(`/publisher/invoice/${pubId}/${pubGuid}/list/0?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            const res = await API.get(`/publisher/invoice/${pubId}/${pubGuid}/pub/list?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            // const data = invoiceList?.data;
            // if(data?.content) {
            //     setInvoiceList(data?.content);  
            //     setPaginationData(data);  
            //     console.log(data?.content);                      
            // }
            // // pagination state
            // // setInvoiceList(invoiceList?.data?.content); 
            // // setTotalPages(invoiceList?.data?.totalPages);
            // // setTotalItems(invoiceList?.data?.totalElements);
            // // setSize(invoiceList?.data?.size); 

            const data = res?.data?.data?.content;
            setPublisherName(res?.data?.name);

            if (res.status === 200 && data) {
                setInvoiceList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setPaginationData(pagination);
            } else {
                setInvoiceList([]);
                setPaginationData({});
            }
        } catch (error) { }
        finally {
            stopLoading();
        }
    }

    const nextPage = (nextPage) => {
        manageInvoiceList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }



    const onChangeSearch = (params) => {
        setSearchConfig(params)
        manageInvoiceList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    // upload invoice case 
    const onSubmit = async (data, actionType) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {

            if (!selectedPub) return;
            const invoiceId = selectedPub?.id;

            console.log("InvoiceID:", invoiceId);
            console.log("ActionType:", actionType);

            const formData = new FormData();
            formData.append("file", data.file[0]);

            // const payload = {
            //     file:data?.file,
            // }

            const res = await API.post(`/publisher/invoice/image/upload/${invoiceId}/${actionType}`, formData);
            closeActionModal();
            if (res?.data?.status === "InvoiceDraft") {
                alert(res?.data?.message);
            } else {
                alert(res?.data?.message);
            }
            // refresh list
            manageInvoiceList("", 0);

        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    // Publish invoice 
    const publishInvoice = async (id, accountId, finalStatus, paymentDate) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const res = await API.put('publisher/invoice/publish/draftInvoice', {
                invId: id,
                accountId: accountId,
                invoiceStatus: finalStatus,
                paymentDate: paymentDate,
            });

            // refresh list
            manageInvoiceList("", 0);
            if (res?.data?.status === "successPubList") {
                alert(res?.data?.message);
            } else {
                alert(res?.data?.message);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    // common function for downlaod any file
    const downloadFileFn = (filePath, blobData) => {
        const fileName = filePath?.split("/").pop();

        const url = window.URL.createObjectURL(new Blob([blobData]));

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);
        alert("File Downloaded Successfully!!");
    };

    const downloadInvoice = async (invoiceFile, invoiceMonth, invoiceYear) => {
        // if(submittingRef.current) return;
        // submittingRef.current = true;
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post('/publisher/invoice/download/file',
                {
                    fileName: invoiceFile,
                    invoiceMonth: invoiceMonth,
                    invoiceYear: invoiceYear,
                },
                { responseType: "blob" }
            );
            downloadFileFn(invoiceFile, response.data);
        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file!");
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }

        // common function for downlaod any file
        // const fileName = invoiceFile?.split("/").pop();

        // const url = window.URL.createObjectURL(new Blob([response.data]));

        // const a = document.createElement("a");
        // a.href = url;
        // a.download = fileName;
        // document.body.appendChild(a);
        // a.click();

        // a.remove();
        // window.URL.revokeObjectURL(url);
    }
    // Downlaod payment advice
    const downloadPaymentAdvice = async (id, accountGuid, filePath) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post('/publisher/invoice/paymentAdvice/download',
                { id, accountGuid, filePath },
                { responseType: "blob" }
            );
            downloadFileFn(filePath, response.data);
        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file!");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    // Coverred date in to readble format
    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();

        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        const seconds = String(date.getUTCSeconds()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        if (pubGuid) {
            manageInvoiceList("", 0);
        }
    }, [pubGuid])

    return (
        <>
            <FormLoader isLoading={isLoading} text={"Loading..."}>
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <Permission code={AUTH_CODE.accounts.publisherListing}>
                        <Link to={'/active-publisher'}><span>Publisher</span></Link>
                    </Permission>
                    {/* <span>{publisherName}</span> */}
                    <Link to={`/publisher/info/${pubId}/${pubGuid}`}><span>{publisherName}</span></Link>
                    <span>Manage Invoice</span>
                    {/* <span>{pubId}</span> */}
                </div>
                <h6 className="title mb-4 mt-4">Invoice Listing</h6>
                <Card className='mb-2'>
                    <div className="d-flex gap-2 flex-nowrap activePubAllBtns">
                        {/* <button style={{borderRadius:"0", padding:"7px 12px", fontSize:"14px"}}>
                <Link to={`/add-invoice/${guid}`} state={{ pubGuid:invoiceList?.[0]?.accountGuid, pubId:invoiceList?.[0]?.accountId }}><BiPlus /> Create Invoice </Link>
            </button> */}
                        <FilterBar defaultOrder={"asc"} defaultField={tableFields[0].value} fields={tableFields} onSearch={onChangeSearch} />
                    </div>
                    <div className="mt-0 table-wrapper mt-3">
                        {/* <div className="table-scroll"> */}
                        <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                            <thead>
                                <tr>
                                    {/* <th>Invoice Series</th>
                                <th>Invoice Month</th>
                                <th>Invoice Year</th>
                                <th>Payment Date</th>
                                <th>Payment Amount</th>
                                <th>Description</th>
                                <th>Approve Status</th>
                                <th>Invoice File</th>
                                <th>Status</th>
                                <th>Created On</th>
                                <th>Updated On</th>
                                <th>Action</th> */}

                                    <th>☰</th>
                                    {
                                        tableFields?.map((item, i) => {
                                            if (!item.enableTableHeader) {
                                                return false;
                                            }
                                            return (
                                                <th key={i}>
                                                    {item.label}
                                                    {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                                                </th>
                                            )
                                        })
                                    }
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    invoiceList.length > 0 ?
                                        invoiceList?.map((invList, index) => (
                                            <tr key={index}>
                                                <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                                {/* <td>{invList?.id || '-'}</td> */}
                                                <td>{invList?.invoiceSeries || '-'}</td>
                                                <td>{invList?.invoiceMonth || '-'}</td>
                                                <td>{invList?.invoiceYear || '-'}</td>
                                                <td>{invList?.paymentDate?.split("T")[0] || '-'}</td>
                                                <td>{invList?.paymentAmount || '-'}</td>
                                                <td>{invList?.description || '-'}</td>
                                                <td>{invList?.approveStatus || '-'}</td>
                                                <td>{invList?.invoiceFile || '-'}</td>
                                                <td>{invList?.invoiceStatus || '-'}</td>
                                                <td>{invList?.status || '-'}</td>
                                                <td>{formatDateTime(invList?.createdAt) || '-'}</td>
                                                <td>{formatDateTime(invList?.updatedAt) || '-'}</td>
                                                <td>
                                                    <div className="d-flex gap-2 flex-nowrap activePubAllBtns justify-content-center">
                                                        <Permission code={AUTH_CODE.publisherInvoice.publishDraftInvoice}>
                                                            {[1, 3].includes(invList?.finalStatus) ? (
                                                                <button disabled={btnClicked} onClick={() => publishInvoice(invList?.id, invList?.accountId, invList?.finalStatus, invList?.paymentDate)}> Publish invoice <LuSquareArrowUp /></button>
                                                            ) : ''}
                                                        </Permission>
                                                        <Permission code={AUTH_CODE.publisherInvoice.downloadInvoice}>
                                                            {[1, 2, 3, 4, 5, 6].includes(invList?.finalStatus) ? (
                                                                <button disabled={btnClicked} onClick={() => downloadInvoice(invList?.invoiceFile, invList?.invoiceMonth, invList?.invoiceYear)}> Download invoice <LuDownload /></button>
                                                            ) : ''}
                                                        </Permission>
                                                        <Permission code={AUTH_CODE.financeInvoice.downloadPaymentAdvice}>
                                                            {[6].includes(invList?.finalStatus) && (invList?.filePath) ? (
                                                                <button disabled={btnClicked} onClick={() => downloadPaymentAdvice(invList?.id, invList?.accountGuid, invList?.filePath)}> Download Payment Advice <LuArrowDownToLine /> </button>
                                                            ) : ''}
                                                        </Permission>
                                                        <Permission code={AUTH_CODE.publisherInvoice.uploadInvoice}>
                                                            {[0, 1, 3].includes(invList?.finalStatus) ? (
                                                                <button onClick={() => openActionModal(invList)}> Upload invoice <LuArrowUpToLine /></button>
                                                            ) : ''}
                                                        </Permission>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : <tr><td colSpan={13}>No Data Available</td></tr>
                                }
                            </tbody>
                        </Table>
                        {/* </div> */}
                    </div>
                </Card>
                {/* deactivate modal start */}
                <Modal show={actionModal} onHide={closeActionModal}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Upload File</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Alert variant="success">
                                <p className="mb-0" style={{ fontSizxe: "12px" }}>
                                    "Note : Please upload file or draft it."
                                </p>
                            </Alert>
                            <Row>
                                <Col md={4}><label>Upload File : <span className="text-danger">*</span></label></Col>
                                <Col md={8}>
                                    <Form.Control type="file" {...register("file", { required: "Please upload a file" })} />
                                    {errors.file && <p className="text-danger">{errors.file.message}</p>}
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            {/* <Button type="submit" variant="danger" onClick={()=>{
                            setActionType(1);
                            handleSubmit(onSubmit)();
                        }}> Draft </Button>
                        <Button type="submit" variant="secondary" onClick={()=>{
                            setActionType(0);
                            handleSubmit(onSubmit)();
                            }}> Publish </Button> */}
                            <Permission code={AUTH_CODE.publisherInvoice.uploadInvoice}>
                                <Button
                                    variant="danger"
                                    onClick={() => handleSubmit((data) => onSubmit(data, 1))()}
                                >
                                    Draft
                                </Button>

                                <Button
                                    variant="secondary"
                                    onClick={() => handleSubmit((data) => onSubmit(data, 0))()}
                                >
                                    Publish
                                </Button>
                            </Permission>
                        </Modal.Footer>
                    </Form>
                </Modal>
                <Pagination
                    jumpPage={true}
                    initCall={false}
                    count={true}
                    component={PubInvoiceList.name}
                    size={"sm"}
                    paginationData={paginationData}
                    nextPage={nextPage} />
            </FormLoader>
        </>
    )
}

export default PubInvoiceList;